import { until } from "@vueuse/core";
import { computed, watch } from "vue";
import { type ProductInTree } from "@/stores/products-store";
import { BaseLinkedEntitiesManager } from "../mystekz-linked-entities/manager";
import { ProductEntity } from ".";
import { useWorktreeManager } from "@/composables/worktree-manager";

/**
 * Manages the business entities and replaces
 */
export class ProductsManager extends BaseLinkedEntitiesManager<ProductEntity> {
    nodeType = "product" as const;
    worktreeManager = useWorktreeManager();

    constructor(baseUrl: string) {
        super(baseUrl);
        const isLoading = computed(() => {
            return (
                this.worktreeManager.isFetching.value ||
                this.organizationManager.isLoadingOrganizations.value ||
                this.stekManager.isLoadingSteks.value
            );
        });
        this.ready = until(isLoading).not.toBeTruthy();

        watch(
            this.worktreeManager.worktree,
            (newWorktree) => {
                if (newWorktree) {
                    const products: ProductInTree[] = [];
                    for (const d of newWorktree.domains) {
                        for (const p of d.products) {
                            products.push(p);
                        }
                    }
                    this.setEntities(products);
                }
            },
            { immediate: true }
        );
    }
}
